import { useEffect, useState, useRef } from "react";
import { Col, Row, Overlay, Button, Popover } from "react-bootstrap";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import storage from "../../../apis/Storage";
import FormikControl from "../../../layouts/Input/FormikControl";
import {
  GET_DISTRIBUTOR_DDL,
  GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
} from "../../../Types";
import {
  getDropdownList,
  getDropdownListByPost,
} from "../../Shared/dropdownListActions";
import axios from "../../../apis/Api";
import { Link } from "react-router-dom";
import {
  renderCell,
  renderHeader,
  toCommaSeparated,
} from "../../../utilities/FUNCTIONS";
import {
  GetDisputedTransactionsReport,
  downloadJob,
} from "./DisputedTransactionsReportActions";
import Moment from "react-moment";

const DisputedTransactionsReport = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const userRights = JSON.parse(storage.get("_userRights"));
  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  const [distributorList, setDistributorList] = useState([]);
  const [distCenterList, setdistCenterList] = useState([]);
  const [deliveryManNameList, setDeliveryManNameList] = useState([]);
  const [filter, setfilter] = useState({
    distributor: [],
    distCenter: [],
    distributorId: "",
    distCenterId: "",
    vizId: "",
    invoiceNo: "",
    deliveryman: [],
    deliverymanId: "",
    fromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
    toDate: new Date(),
    pageNo: 0,
    pageSize: 5,
    searchText: null,
    isExport: false,
  });

  const Columns = [
    {
      Header: "Dist Center",
      accessor: "distCenterName",
    },
    {
      Header: "VIZ ID",
      accessor: "vizId",
    },
    {
      Header: "Shop Code",
      accessor: "shopCode",
    },
    {
      Header: "Invoice No.",
      accessor: "invoiceNo",
    },
    {
      Header: "Deliveryman Name",
      accessor: "deliverymanName",
    },
    {
      Header: "Date",
      accessor: "transactionDateTime",
    },
    {
      Header: renderHeader("Invoice Amount"),
      accessor: "invoiceAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Paid Amount"),
      accessor: "paidAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
  ];

  const handleResetFilters = (resetForm) => {
    resetForm();
    setfilter({
      distributor: [],
      distributorId: "",
      distCenter: [],
      distCenterId: "",
      vizId: "",
      invoiceNo: "",
      deliveryman: [],
      deliverymanId: "",
      fromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      toDate: new Date(),
      pageNo: 0,
      pageSize: 5,
      searchText: null,
      isExport: false,
    });
  };

  const Download = () => {
    props.downloadJob(filter);
  };

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL,
    );
    props.GetDisputedTransactionsReport({
      ...filter,
      distributorId:
        filter.distributor?.length > 0
          ? toCommaSeparated(filter.distributor)
          : null,
      distCenterId:
        filter.distCenter?.length > 0
          ? toCommaSeparated(filter.distCenter)
          : null,
    });
  }, []);

  useEffect(() => {
    props.GetDisputedTransactionsReport({
      ...filter,
      distributorId:
        filter.distributor?.length > 0
          ? toCommaSeparated(filter.distributor)
          : null,
      distCenterId:
        filter.distCenter?.length > 0
          ? toCommaSeparated(filter.distCenter)
          : null,
      deliverymanId:
          filter.deliveryman?.length > 0
            ? toCommaSeparated(filter.deliveryman)
            : null,
    });
  }, [filter.pageNo, filter.pageSize, filter.searchText]);

  const getData = (page) => {
    setfilter({ ...filter, pageNo: page });
  };

  const pageSizeChanged = (pageSize) => {
    setfilter({ ...filter, pageSize: pageSize });
  };

  const searchChanged = (text) => {
    setfilter({ ...filter, searchText: text, pageNo: 0 });
  };

  const LoadDataByfilter = (event) => {
    setShow(false);
    setTarget(null);
    if (filter.pageNo != 0) setfilter({ ...filter, pageNo: 0 });
    else
      props.GetDisputedTransactionsReport({
        ...filter,
        distributorId:
          filter.distributor?.length > 0
            ? toCommaSeparated(filter.distributor)
            : null,
        distCenterId:
          filter.distCenter?.length > 0
            ? toCommaSeparated(filter.distCenter)
            : null,
      });
  };

  useEffect(() => {
    setDistributorList([]);
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorList = props.allDistributorList.filter(
        (x) => x.value == userRights?.distributorId,
      );
      if (distributorList?.length > 0) {
        setfilter((prev) => ({
          ...prev,
          distributor: distributorList.map((item) => ({
            label: item.label,
            value: item.value,
          })),
        }));
      }
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else if (userRights != null && userRights?.userType == "CoreAppUser") {
      let distributorList = props.allDistributorList.filter((x) =>
        userRights?.distributorId.includes(x.value),
      );
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else {
      setDistributorList(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (filter.distributor?.length > 0) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        {
          distributorIds: toCommaSeparated(filter.distributor),
        },
        GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
      );
    }

    setfilter((prev) => ({
      ...prev,
      distCenter: [],
      deliveryman: [],
      deliverymanId: "",
    }));
  }, [filter.distributor]);

  useEffect(() => {
    if (filter.distCenter?.length > 0) {
      getCenterDeliveryUsers(toCommaSeparated(filter.distCenter));
    }

    setfilter((prev) => ({
      ...prev,
      deliveryman: [],
    }));
  }, [filter.distCenter]);
  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distCenterList = props.selectedAddJobDistCentersList.filter((x) =>
        userRights?.distCenterIds.includes(x.value),
      );
      setdistCenterList(
        distCenterList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else {
      setdistCenterList(
        props.selectedAddJobDistCentersList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    }
  }, [props.selectedAddJobDistCentersList]);

  const getCenterDeliveryUsers = (id) => {
    axios
      .get(`api/DistCenter/GetCenterDeliveryUsersDDL/${id}`)
      .then(({ data }) => {
        if (data?.response) {
          setDeliveryManNameList(
            data.response.map(function (item) {
              return {
                value: item.id,
                label: item.fullname,
              };
            }),
          );
        }
      })
      .catch(function (error) {});
  };

  return (
    <div>
      <VzPageContainer title="Disputed Transactions Report">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>Disputed Transactions Report</b>
            </h4>
            <br />
          </Col>
        </Row>
        <Row>
          <Col md={10} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>
              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                width="430px"
                style={{ width: "430px" }}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "360px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={filter}
                      validator={() => ({})}
                      onSubmit={LoadDataByfilter}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Distributor Name"
                              name="distributor"
                              options={distributorList}
                              isClearable={true}
                              isSearchable={true}
                              isMulti={true}
                              handleOnChange={(e) => {
                                setfilter((prev) => ({
                                  ...prev,
                                  distributor: e || [],
                                }));
                              }}
                              value={filter.distributor}
                            />
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Distribution Center"
                              name="distCenter"
                              options={
                                filter.distributor.length > 0
                                  ? distCenterList
                                  : []
                              }
                              isClearable={true}
                              isSearchable={true}
                              isMulti={true}
                              handleOnChange={(e) => {
                                setfilter((prev) => ({
                                  ...prev,
                                  distCenter: e || [],
                                }));
                              }}
                              value={filter.distCenter}
                            />
                            <FormikControl
                              formik={formik}
                              control="input"
                              type="vizId"
                              label="Viz Id"
                              name="vizId"
                              handleOnChange={(value) => {
                                filter.vizId = value;
                              }}
                              value={filter.vizId}
                            />
                            <FormikControl
                              formik={formik}
                              control="input"
                              type="invoiceNo"
                              label="Invoice No."
                              name="invoiceNo"
                              handleOnChange={(value) => {
                                filter.invoiceNo = value;
                              }}
                              value={filter.invoiceNo}
                            />
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Deliveryman Name"
                              name="deliveryman"
                              options={deliveryManNameList ?? []}
                              isClearable={true}
                              isSearchable={true}
                              isMulti={true}
                              handleOnChange={(e) => {
                                setfilter((prev) => ({
                                  ...prev,
                                  deliveryman: e || [],
                                }));
                              }}
                              value={filter.deliveryman}
                            />
                            <Row>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  // formik={formik}
                                  control="date"
                                  label="From Date"
                                  name="fromDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, fromDate: value });
                                  }}
                                  value={filter.fromDate}
                                />
                              </Col>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  // formik={formik}
                                  control="date"
                                  label="To Date"
                                  name="toDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, toDate: value });
                                  }}
                                  value={filter.toDate}
                                />
                              </Col>
                            </Row>
                            <div className="row" style={{ marginTop: 20 }}>
                              <div className="form-group">
                                <Link
                                  onClick={handleResetFilters.bind(
                                    null,
                                    formik.resetForm,
                                  )}
                                  to="#"
                                  className="active"
                                  style={{
                                    padding: "0px",
                                    marginTop: "10px",
                                    float: "left",
                                  }}
                                >
                                  Reset
                                </Link>
                                <Link
                                  onClick={() => {
                                    setShow(false);
                                    setTarget(null);
                                  }}
                                  to="#"
                                  className="active"
                                  style={{
                                    padding: "0px",
                                    marginTop: "10px",
                                    float: "right",
                                  }}
                                >
                                  Cancel
                                </Link>
                                <div className="float-right">
                                  <Button
                                    type="submit"
                                    className="btn btn-primary"
                                    style={{
                                      marginRight: "10px",
                                      float: "right",
                                    }}
                                  >
                                    Apply
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>
          <Col md={2} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={() => Download()}
              className="m-3"
              variant="outline-primary"
            >
              <i className="fa fa-download me-1" />
              Export
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <ServerSideDataTable
              data={props.GetDisputedTransactionsReportData.records ?? []}
              columns={Columns}
              getTrProps={(event, data) => null}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={props.GetDisputedTransactionsReportData.count ?? 0}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={filter.pageSize}
              myIndex={currentIndex}
              pageNo={filter.pageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>
      </VzPageContainer>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    selectedAddJobDistCentersList: state.ddlList.selectedAddJobDistCentersList
      ? state.ddlList.selectedAddJobDistCentersList
      : [],
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],
    GetDisputedTransactionsReportData: state.DisputedTransactionsReport
      ? state.DisputedTransactionsReport
      : [],
  };
};

export default connect(mapStateToProps, {
  getDropdownList,
  getDropdownListByPost,
  GetDisputedTransactionsReport,
  downloadJob,
})(DisputedTransactionsReport);
